import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircleIcon, BuildingOfficeIcon, BuildingLibraryIcon } from '@heroicons/react/24/outline';

const roles = [
  { id: 'parent', title: 'Parent/Carer', icon: UserCircleIcon, description: 'Manage your child\'s care and services', path: '/pa-signup' },
  { id: 'provider', title: 'Provider', icon: BuildingOfficeIcon, description: 'Offer play, education or care services through your organisation', path: '/business-signup' },
  { id: 'authority', title: 'Local Authority', icon: BuildingLibraryIcon, description: 'Oversee and manage local care provisions', path: '/la-signup' },
];

const SignUpRoleChoice = () => {
  const navigate = useNavigate();

  const handleRoleSelect = (path: string) => {
    navigate(path);
    // If not using React Router, you can use:
    // window.location.href = path;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Choose Your Role</h1>
          <p className="text-xl text-gray-600">Select the option that best describes you</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {roles.map((role) => (
            <button
              key={role.id}
              onClick={() => handleRoleSelect(role.path)}
              className="bg-white rounded-xl shadow-md p-6 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 group"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="bg-blue-100 rounded-full p-3 group-hover:bg-blue-200 transition-colors duration-300">
                  <role.icon className="w-8 h-8 text-blue-600" />
                </div>
                <h2 className="text-2xl font-semibold text-gray-800">{role.title}</h2>
                <p className="text-gray-600">{role.description}</p>
                <span className="text-blue-600 font-medium group-hover:underline">Create your account &rarr;</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SignUpRoleChoice;